<template>
    <div v-if="shouldRender">
        <slot></slot>
    </div>
</template>

<script>
    import { h } from 'vue'

    export default {
        data() {
            return {
                shouldRender: false,
            };
        },
        mounted() {
            this.shouldRender = true;
        }
    }
</script>